import withInputErrorMessage from '../withInputErrorMessage';
import withOptionsSelectValueInitById from './withOptionsSelectValueInitById';
import withFormikSelect from './withSelectFormik';

export const options = [
   {
      value: 'INTERNAL',
      label: 'Internal',
      id: 'INTERNAL',
      name: 'Internal',
   },
   {
      value: 'SYNDICATION',
      label: 'Syndication',
      id: 'SYNDICATION',
      name: 'Syndication',
   },
];

export default withFormikSelect(withInputErrorMessage(withOptionsSelectValueInitById(options)));
